module.exports = __webpack_public_path__ + "static/media/date-start.4031385f.svg";